// src/pages/users/user.config.ts
import * as Yup from 'yup';
import { FormFieldConfig } from '../../types/formField.types';
import { userApi } from '../../api/accountsApi';
import { getFormFields, getInitialValues, getTableColumns, getValidationSchema } from '../../utils/fieldConfigHelpers';
import { createdAtField, createdByField, emailField, phoneField, roleField, softDeletedField, statusField, updatedAtField, updatedByField } from '../../utils/formFields';
import { trueFalseOptions } from '../../utils/options';

export const userFieldConfig: FormFieldConfig[] = [
  {
    name: 'fullName',
    label: 'Full Name',
    type: 'text',
    yup: Yup.string().required('Full name is required'), 
    getInitialValue: (data) => data?.fullName || '',
    table: { minWidth: 200 },
    example: 'John Doe',
  },
  emailField(),
  phoneField(),
  roleField(),
  {
    name: 'sendTempPassword',
    label: 'Generate Temporary Password & Send Email',
    type: 'switch', 
    showOn: ['create'],
    infoMessage: 'This will generate a temporary password and send it to the user via email.',
    example: false,
  },
  {
    name: 'password',
    label: 'Password',
    type: 'password',
    yup: Yup.string().when('$mode', (mode: unknown, schema) => {
      const formMode = typeof mode === 'string' ? mode : Array.isArray(mode) ? mode[0] : '';
      return formMode === 'edit'
        ? schema.min(6, 'Password must be at least 6 characters') // Optional validation for edit mode
        : schema;
    }), 
    showOn: ['edit'],
    infoMessage: 'Leave blank if you do not want to update the password.',
    example: 'password123',
  },
  {
    name: 'mustResetPassword',
    label: 'Force To Reset Password',
    type: 'switch',
    options: trueFalseOptions, 
    showOn: ['edit', 'table'],
    table: {
      valueGetter: (params) => (params.data?.mustResetPassword ? 'Yes' : 'No'),
    },
    infoMessage: 'If checked, user must reset password on next login.',
    example: true,
  },
  statusField(),
  createdAtField(),
  updatedAtField(),
  softDeletedField(),
  {
    name: 'failedLoginAttempts',
    label: 'Failed Login Attempts',
    showOn: ['table'],
    example: 3,
  },
  createdByField(),
  updatedByField(),
];


export const userFormFields = getFormFields(userFieldConfig);// ✅ Form Fields  
export const userFormSchema = getValidationSchema(userFieldConfig);// ✅ Yup Validation Schema 
export const userFormInitialValues = (data: any) => getInitialValues(userFieldConfig, data); // ✅ Initial Values 
export const userTableColumns = getTableColumns(userFieldConfig); // ✅ Table Columns 

// ✅ Module Config
export const userConfig = {
  entityName: 'User',
  redirectPath: '/accounts/users',
  userTableColumns,
  api: userApi,
};